import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { fetchLeagueView } from '../../api/api';
import LeagueOverallRanking from './LeagueOverallRanking';
import LeagueAwards from './LeagueAwards';
import Spinner from '../Spinner/Spinner';
import styles from './LeagueRankingPage.module.css';

const LeagueRankingPage = () => {
    const { tournamentId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            const result = await fetchLeagueView(tournamentId);
            if (result.success) {
                setData(result.data);
            }
            setIsLoading(false);
        };
        loadData();
    }, [tournamentId]);

    const handleBack = () => {
        const returnPath = location.state?.returnPath;
        if (returnPath) {
            navigate(returnPath, { state: location.state.returnState });
        } else {
            navigate(-1);
        }
    };

    if (isLoading || !data) return <Spinner />;

    return (
        <div className={styles.container}>
            <div className={styles.topBar}>
                <button className={styles.backButton} onClick={handleBack}>
                    &#8592; Powrót
                </button>
                <a href="/liga-info" className={styles.infoLink}>opis ligi</a>
            </div>
            <div className={styles.header}>
                <p className={styles.tournamentName}>{data.tournament?.name}</p>
            </div>
            <LeagueOverallRanking
                rankings={data.overallRanking}
                config={data.config}
                groups={data.groupStandings}
            />
            <LeagueAwards awards={data.leagueAwards} />
        </div>
    );
};

export default LeagueRankingPage;
